import { Pipe, PipeTransform } from '@angular/core';
import { BreadcrumbService } from '../breadcrumb/breadcrumb.service';

@Pipe({
	name: 'breadcrumbTrans'
})

/**
 * BreadcrumbTranslatePipe translates labels for the breadcrumb component
 */
export class BreadcrumbTranslatePipe implements PipeTransform
{
	constructor(private breadcrumbService: BreadcrumbService)
	{
	}

	/**
	 * Returns a translated breadcrumb label for a given key and category
	 *
	 * @param {string} value
	 *
	 * @returns {string}
	 */
	transform(value: string): string
	{
		if (this.breadcrumbService.translations && this.breadcrumbService.translations.hasOwnProperty(value)) {
			return this.breadcrumbService.translations[value];
		}

		return value;
	}
}



// WEBPACK FOOTER //
// ./src/app/pipes/breadcrumb-translate.pipe.ts